// Priority Fee Presets
export const PRIORITY_FEES = {
  economy: { value: 0.0001, label: 'Economy', description: 'Slower (~30s)' },
  standard: { value: 0.0005, label: 'Standard', description: 'Normal (~15s)' },
  turbo: { value: 0.001, label: 'Turbo', description: 'Fast (~5s)' }
};

// Validation Limits
export const VALIDATION = {
  name: { min: 1, max: 32 },
  symbol: { min: 1, max: 10 },
  description: { min: 1, max: 500 },
  imageMaxSize: 5 * 1024 * 1024 // 5MB
};

// Network Configuration
// Backend URL for API proxy
function getBackendUrl() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'yobitch.fun' || hostname === 'www.yobitch.fun') {
      return process.env.REACT_APP_RAILWAY_URL || 'https://api.yobitch.fun';
    }
    if (hostname.includes('vercel.app')) {
      return process.env.REACT_APP_RAILWAY_URL || 'https://api.yobitch.fun';
    }
  }
  
  return 'http://localhost:3001';
}

const BACKEND_URL = getBackendUrl();

// RPC endpoints - use public RPC for frontend, Helius via backend proxy for sensitive ops
// SECURITY: Never expose API keys in frontend code
const MAINNET_ENDPOINT = 'https://api.mainnet-beta.solana.com';

export const NETWORKS = {
  mainnet: {
    name: 'Mainnet',
    endpoint: MAINNET_ENDPOINT,
    backendUrl: BACKEND_URL
  },
  devnet: {
    name: 'Devnet',
    endpoint: 'https://api.devnet.solana.com',
    backendUrl: BACKEND_URL
  }
};

// Launch Steps
export const LAUNCH_STEPS = [
  { id: 'upload', label: 'Upload', description: 'Uploading to IPFS' },
  { id: 'create', label: 'Create', description: 'Creating transaction' },
  { id: 'sign', label: 'Sign', description: 'Sign in wallet' },
  { id: 'send', label: 'Send', description: 'Sending to network' },
  { id: 'confirm', label: 'Confirm', description: 'Confirming on chain' }
];

// Estimated Costs (in SOL)
export const ESTIMATED_COSTS = {
  baseFee: 0.002, // Base network fee for token creation (~0.002 SOL)
  rentExempt: 0 // Rent is included in the pump.fun fee
};

// Trust Score Configuration
export const TRUST_SCORE_CONFIG = {
  thresholds: {
    safe: 30,      // Top 10 wallets hold < 30% = SAFE
    caution: 50,   // Top 10 wallets hold 30-50% = CAUTION
    danger: 100    // Top 10 wallets hold > 50% = DANGER
  },
  labels: {
    safe: { text: 'LOW RISK', color: '#7FFF00', icon: 'shield-check' },
    caution: { text: 'MEDIUM RISK', color: '#FFD700', icon: 'alert-triangle' },
    danger: { text: 'HIGH RISK', color: '#FF6B6B', icon: 'alert-octagon' }
  }
};

// Bundle Launch Configuration
export const BUNDLE_CONFIG = {
  maxWallets: 20,
  minWallets: 2,
  defaultWalletCount: 5,
  defaultBuyAmount: 0.01, // SOL per wallet
  defaultBuyRange: { min: 0.005, max: 0.02 }, // Random range for organic look
  txFeeBuffer: 0.01, // Extra SOL per wallet for transaction fees
  description: 'Launch with multiple wallets buying simultaneously for organic-looking distribution',
  stealthMode: {
    enabled: true,
    randomizeAmounts: true,
    freshWalletsOnly: true
  }
};

// Vanity Address Configuration
export const VANITY_CONFIG = {
  maxLength: 4,
  timeEstimates: {
    1: '< 1 second',
    2: '~5 seconds',
    3: '~30 seconds',
    4: '~15 minutes'
  },
  maxAttempts: 5000000,
  batchSize: 10000
};

// Theme Colors
export const THEMES = {
  dark: {
    bg: '#0f1219',
    bgSecondary: '#1a1f2e',
    text: '#f8fafc',
    textMuted: 'rgba(248, 250, 252, 0.6)',
    accent: '#6366f1',
    accentGreen: '#22c55e',
    accentOrange: '#f59e0b',
    error: '#ef4444',
    success: '#22c55e',
    border: 'rgba(255, 255, 255, 0.15)',
    glass: 'rgba(26, 31, 46, 0.96)'
  },
  light: {
    bg: '#f5f5f7',
    bgSecondary: '#ffffff',
    text: '#1a1a1a',
    textMuted: 'rgba(0, 0, 0, 0.5)',
    accent: '#9a8a28',
    accentGreen: '#22c55e',
    accentOrange: '#f97316',
    error: '#ef4444',
    success: '#22c55e',
    border: 'rgba(0, 0, 0, 0.1)',
    glass: 'rgba(255, 255, 255, 0.9)'
  }
};
